/* eslint-disable no-restricted-globals */
import Modal from 'react-modal';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { HashRouter, Route } from 'react-router-dom';
import SignInSignUpContainer from '../app/SignInSignUpContainer';
import { changeDefaultTab } from './modalActions';
import ForgotYourPasswordContainer from '../reset-password/ForgotYourPasswordContainer';
import CheckYourInBoxContainer from '../reset-password/CheckYourInBoxContainer';
import { registrationSuccess } from '../register/RegisterActions';

class AppModal extends React.Component {
  constructor(props) {
    super(props);
    this.customer = {};
  }

  componentDidMount() {
    document.addEventListener('loginRequested', (e) => {
      this.customer = (e.detail && e.detail.customer) || {};
      this.props.openModal(e);
      window.location.hash = 'sign-in';
    });

    document.addEventListener('loginClose', () => {
      this.props.onCloseModal();
    });

    document.addEventListener('setLoginStatus', (e) => {
      this.props.setLoginStatus(e.detail.isLoggedIn);
    });

    document.addEventListener('signInSignUpModalRequested', (e) => {
      if (e.detail.selectedTab === 'signIn') {
        this.props.changeDefaultTab('signIn');
      } else if (e.detail.selectedTab === 'signUp') {
        this.props.changeDefaultTab('signUp');
      }

      this.props.openModal(e);

      window.location.hash = 'sign-in';
    });
  }

  static onSigninSuccess() {
    document.body.setAttribute('data-is-authenticated', true);
    if (window.location.href.toLowerCase().endsWith('orderstatus')) {
      window.location.href = `${window.location.origin}/myaccount/dashboard`;
      return;
    }
    if (location.hash) {
      window.location.href = window.location.href.replace(location.hash, '');
    }
  }

  render() {
    return (
      <Modal
        isOpen={this.props.isOpen}
        ariaHideApp={false}
        contentLabel="Modal"
        onRequestClose={this.props.onCloseModal}
        closeTimeoutMS={200}
        className="gcc-modal external-close"
        overlayClassName="gcc-modal-overlay"
        style={{
          content: {
            width: 'calc(100% - 20px)',
            maxWidth: 315,
          },
        }}
      >
        <i
          role="button"
          tabIndex={0}
          className="material-icons white pointer modal-close absolute right-0 top--2 z-max f2 f1-m nt2 nt3-m nr2"
          onClick={this.props.onCloseModal}
        >
          close
        </i>
        <HashRouter hashType="noslash">
          <div>
            <Route
              path="/sign-in"
              render={() => (
                <SignInSignUpContainer
                  forgotPasswordPath="reset"
                  customer={this.customer}
                  defaultTab={this.props.defaultTab}
                  onSigninSuccess={() => AppModal.onSigninSuccess()}
                  onRegistrationSuccess={(dispatch) => {
                    dispatch(registrationSuccess());
                    AppModal.onSigninSuccess();
                  }}
                />
              )}
            />
            <Route path="/reset" render={() => <ForgotYourPasswordContainer />} />
            <Route path="/check" component={CheckYourInBoxContainer} />
          </div>
        </HashRouter>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    defaultTab: state.modal.defaultTab,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    changeDefaultTab: newDefaultTab => dispatch(changeDefaultTab(newDefaultTab)),
  };
}

AppModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onCloseModal: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired,
  setLoginStatus: PropTypes.func.isRequired,
  changeDefaultTab: PropTypes.func.isRequired,
  defaultTab: PropTypes.string.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(AppModal);
